<template>
<div id="MediaPlayer">
  <div class="course-live-wrap">
    <object
      id="flashObject"
      v-show="!flashEnable"
      type="application/x-shockwave-flash"
    ></object>
    <div class="media">
      <video
        id="video-live"
        class="video-js vjs-big-play-centered video-custom-class"
        webkit-playsinline
        playsinline
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="landscape"
      ></video>
      <!-- <div class="player-controller">
        <PlayerControls :player="player"></PlayerControls>
      </div> -->
      <div
        class="not-living-wrap"
        v-if="!player"
        :style="{'background-image': `url(${cover})`}"
      >
        <div class="not-living-tips">{{ notLivingTip }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Loading from '@/components/ui/Loading'
import {
  mapActions,
  mapState,
} from 'vuex'
import playerConfig from '@/constant/nimConfig'
import PlayerControls from './PlayerControls'
import controlPlugin from '@/plugins/controlsPlugin'
import {
  formatter,
} from '@/utils/durationFormat'
import videojs from 'video.js'
import 'videojs-flash'
import { COURSE_STATE } from '@/constant/constants'
const TYPES = {
  netease: {
    value: 1,
  },
  tencent: {
    value: 2,
  },
}

export default {
  name: '',
  props: {
    courseId: {
      type: String,
      required: true,
    },
    cover: {
      type: String,
      required: true,
    },
    startTime: {
      type: [Number, String],
      required: true,
    },
    onlineMemberNum: {
      type: Number,
      required: true,
    },
    channel: {
      type: String,
    },
    state: {
      type: Number,
      required: true,
    },
    expectStartTime: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    PlayerControls,
    Loading,
  },
  data () {
    return {
      player: null,
      flashEnable: false,
      startTimeSelf: 0,
      faultToleranceTimer: '',
      pollingTimer: '',
      onErrorDebounce: '',

      httpPullUrl: '',

      liveDurationEle: null,
      audienceCountEle: null,
      LoadingCoverEle: null,

      notLivingTip: '',

      loading: false,
      playing: false,
    }
  },
  computed: {
    ...mapState('course', ['courseDetail']),
  },
  methods: {
    ...mapActions({
      getCourseDetail: 'course/getCourseDetail',
      getChannelAddress: 'live/getChannelAddress',
      getTranscode: 'live/getTranscode',
    }),
    init () {
      this.getTranscode({ type: TYPES.netease.value, mixId: this.channel }).then((address) => {
        this.addressTranscode = address
        this.initPlayer()
      })
    },
    initPlayer () {
      const that = this
      let conf = Object.assign({
        poster: this.cover,
      }, playerConfig.initConfig)
      this.player = videojs('video-live', conf, () => {
        // 当播放器初始化完成时运行的回调函数
        this.player.src({
          src: that.addressTranscode.transcodeHttpPullUrl['_1280'],
          type: 'video/x-flv',
        })

        // 设置播放器的自定义组件
        that.player.addChild(controlPlugin.getChangeClarityTriggerInstance(), {})
        that.player.addChild(controlPlugin.getChangeClarityOptionsInstance(), {})
        that.player.addChild(controlPlugin.getChangeChannel(null, (e, val) => {
          that.handleChangeChannel(val)
        }, null
        ), {})
        that.player.addChild(controlPlugin.getPlayButtonInstance(that.player), {})
        that.player.addChild(controlPlugin.getLoadingInstance(that.player), {})
        // let audienceCountEle = document.querySelector('#video-live .audience-amount')
        // that.audienceCountEle = audienceCountEle
        // audienceCountEle.innerHTML = `${that.onlineMemberNum}人在线`

        that.player.play()
        // that.player.onError(that.onError)
        that.addPlayerListener()
      })
    },
    onError (e) {
      let that = this
      clearTimeout(this.onErrorDebounce)

      this.onErrorDebounce = setTimeout((e) => {
        if (e.errCode === 7) {
          that.getCourseDetail({
            courseId: that.courseId,
          }).then(({
            state,
          }) => {
            (state === COURSE_STATE.LIVING || state === COURSE_STATE.FORECAST) && that.player.refresh()
            that.state = state
          })
        }
      }, 1500, e)
    },
    renderDuration () {
      this.duration = Date.now() - this.startTimeSelf
      if (!this.liveDurationEle) {
        let liveDurationEle = document.querySelector('#video-live .live-duration')
        if (liveDurationEle) {
          this.liveDurationEle = liveDurationEle
          liveDurationEle.innerHTML = formatter(this.duration)
        }
      } else {
        this.liveDurationEle.innerHTML = formatter(this.duration)
      }
    },
    addPlayerListener () {
      let controlBar = document.querySelector('#video-live .vjs-control-bar')
      // 增加loading的监听
      this.player.on('loadstart', () => {
        this.loading = true
        this.LoadingCoverEle = this.LoadingCoverEle || document.querySelector('#video-live .custom-plugin-loading-wrap')
        this.LoadingCoverEle.style.display = 'flex'
        this.judgeControlBarStatus(controlBar)
      })
      this.player.on('canplay', () => {
        this.loading = false
        this.LoadingCoverEle = this.LoadingCoverEle || document.querySelector('#video-live .custom-plugin-loading-wrap')
        this.LoadingCoverEle.style.display = 'none'
        this.judgeControlBarStatus(controlBar)
      })
      // 增加对于播放状态的监听[1: 播放中， 2： 暂停中]
      // this.player.on('playState', (ev) => {
      //   this.playing = true
      //   this.pauseCoverEle = this.pauseCoverEle || document.querySelector('#video-live .custom-plugin-pause-cover')
      //   this.pauseCoverEle.style.display = 'none'
      //   this.judgeControlBarStatus(controlBar)
      // })
      // this.player.on(2, () => {
      //   this.playing = false
      //   this.pauseCoverEle = this.pauseCoverEle || document.querySelector('#video-live .custom-plugin-pause-cover')
      //   this.pauseCoverEle.style.display = 'block'
      //   this.judgeControlBarStatus(controlBar)
      // })

      document.querySelector('#video-live .custom-plugin-pause-cover').addEventListener('click', () => {
        this.player.play()
      })
    },
    judgeControlBarStatus (controlBar) {
      if (this.loading || !this.playing) {
        controlBar.style.visibility = 'hidden'
      } else {
        controlBar.style.visibility = 'visible'
      }
    },
    handleChangeChannel (val) {
      this.getTranscode({ type: val, mixId: parseInt(val) === TYPES.netease.value ? this.channel : this.courseId }).then((address) => {
        this.addressTranscode = address.transcodeHttpPullUrl
        this.player.src({
          src: address.transcodeHttpPullUrl['_1280'],
          type: 'video/x-flv',
        })
      })
    },
  },
  mounted () {
    this.flashEnable = window.neplayer.checkFlash()
    this.init()
  },
  destroyed () {
    this.player.dispose()
    this.player = null
    clearTimeout(this.onErrorDebounce)
  },
}
</script>

<style lang="scss">
@import '@/styles/media.scss';
</style>
